import {
    useEffect,
    memo,
    Fragment,
    useState
} from 'react'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useDashboard } from '@app/layouts/dashboard/Provider'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ListSubheader from '@mui/material/ListSubheader'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import LinearProgress from '@mui/material/LinearProgress'
import RefreshButton from './Refresh'
import EstimationsList from '@shared/components/estimations/List'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { Collapse } from '@mui/material'

export default memo(function QuickLook() {
    const { setTitle } = useDashboard()
    const [openedCollapse, setOpenedCollapse] = useState()

    // data
    const query = useRestFetch({
        key: ['quick-look'],
        endpoint: 'estimations/quick-look/'
    })

    useEffect(() => {
        setTitle('نظرة سريعة')
    }, [])

    return (
        <Stack sx={{
            height: '100%',
            overflow: 'hidden'
        }}>
            <RefreshButton />
            {query.isFetching
                ? <LinearProgress />
                :
                    <>
                        <List sx={{
                            height: '100%',
                            overflow: 'auto'
                        }}>
                            {query.data.my_estimations.length > 0 &&
                                <>
                                    <ListSubheader sx={{top: -10}}>آخر تعديل</ListSubheader>
                                    <EstimationsList
                                        estimations={query.data.my_estimations}
                                        itemsOnly={true}
                                    />
                                    <Divider />
                                </>
                            }
                            {query.data.today_estimations.length > 0 &&
                                <>
                                    <ListSubheader sx={{top: -10}}>مقايسات اليوم</ListSubheader>
                                    <EstimationsList
                                        estimations={query.data.today_estimations}
                                        itemsOnly={true}
                                    />
                                    <Divider />
                                </>
                            }
                            {query.data.active_users_today.length > 0 &&
                                <ListSubheader sx={{top: -10}}>المهندسين النشطين</ListSubheader>
                            }
                            {query.data.active_users_today.map(user =>
                                <Fragment key={user.id}>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            selected={openedCollapse == user.id}
                                            onClick={() => {
                                                if (openedCollapse == user.id) {
                                                    setOpenedCollapse()
                                                } else {
                                                    setOpenedCollapse(user.id)
                                                }
                                            }}
                                        >
                                            <ListItemIcon>
                                                {openedCollapse == user.id
                                                    ? <ArrowDropUpIcon />
                                                    : <ArrowDropDownIcon />
                                                }
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={user.name}
                                                secondary={user.last_activity}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <Collapse
                                        in={openedCollapse == user.id}
                                        unmountOnExit
                                    >
                                        <List disablePadding>
                                            {user.logs.length > 0
                                                ? user.logs.map(log =>
                                                    <ListItem
                                                        key={log.id}
                                                        disablePadding
                                                        sx={{pl: 9}}
                                                    >
                                                        <ListItemText
                                                            primary={`${log.action} ${log.model_name} "${log.object_repr}"`}
                                                            secondary={log.time_ago}
                                                        />
                                                    </ListItem>
                                                )
                                                :
                                                    <ListItem
                                                        disablePadding
                                                        sx={{pl: 9}}
                                                    >
                                                        <ListItemText primary='لا توجد حركات مسجّلة اليوم' />
                                                    </ListItem>
                                            }
                                        </List>
                                    </Collapse>
                                </Fragment>
                            )}
                        </List>
                        <Divider />
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            p: 1,
                            gap: 2
                        }}>
                            <Typography variant='body2'>الإجمالي: {query.data.estimations_count}</Typography>
                        </Box>
                    </>
            }
        </Stack>
    )
})